import React from "react";
import { Box, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const renderInfo = (
  label: string,
  value: string,
  fullWidth?: boolean,
  multiline?: boolean,
  isEmail?: boolean
) => (
  <Grid size={{ xs: fullWidth ? 12 : 6, sm: fullWidth ? 12 : 4 }}>
    <Typography
      variant="body2"
      sx={{
        fontSize: { xs: "8px", sm: "14px" },
        fontWeight: 500,
        paddingBottom: "5px",
        fontFamily: "Roboto",
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="body1"
      sx={{
        paddingY: 0.5,
        border: "1px solid #C5CED6",
        borderRadius: 1,
        padding: "8px",
        fontSize: { xs: "10px", sm: "13px" },
        width: fullWidth ? "100%" : "auto",
        minHeight: multiline ? "80px" : "20px",
        whiteSpace: multiline ? "pre-wrap" : "normal",
        fontFamily: "Roboto",
      }}
    >
      {value}
    </Typography>
  </Grid>
);

export const renderDocuments = (
  documents: { name: string; link: string }[],
  onPreview: (link: string) => void
) => (
  <Box display="flex" gap={3} flexWrap="wrap">
    {documents.map((doc, index) => (
      <Button
        key={index}
        variant="outlined"
        color="primary"
        sx={{
          fontSize: "14px",
          borderRadius: "2px",
          border: "1px solid #767676",
          justifyContent: "space-between",
          background: "#EFEFEF",
          width: "auto",
          padding: "8px 16px",
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => {
          console.log("Document link clicked:", doc.link);
          onPreview(doc.link);
        }}
      >
        {doc.name}
      </Button>
    ))}
  </Box>
);
